
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30778',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30778",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55304",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8328",
  "hubspot-dlb": "static-2.1882",
  "HubStyleTokens": "static-2.11787",
  "I18n": "static-7.1672",
  "quartz": "static-1.7451",
  "quartz-config": "static-1.1229",
  "quartz-core": "static-1.6670",
  "react-dlb": "static-1.88",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.80",
  "reselect": "static-3.12",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.916",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55291",
  "feedback-utils": "static-1.55295",
  "forms-embed-utils-lib": "static-1.4761",
  "forms-utils-lib": "static-1.13088",
  "foundations-assets": "static-1.5182",
  "foundations-components": "static-1-ech-accordiontransition-jank.34",
  "foundations-theming": "static-1.4772",
  "hub-http": "static-1.6509",
  "hubspot-url-utils": "static-1.4297",
  "HubStyle": "static-2.12094",
  "icons": "static-2.682",
  "immutable": "static-2.83",
  "quick-fetch": "static-1.4127",
  "raven": "static-3.5925",
  "react": "static-7.192",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1.17016",
  "react-select-plus": "static-1.113",
  "react-utils": "static-2.5554",
  "react-virtualized": "static-2.107",
  "redux": "static-4.76",
  "StyleGuideUI": "static-3.501",
  "tinymce-plugins": "static-1.58209",
  "transmute": "static-2.97",
  "ui-images": "static-2.1247",
  "UIComponents": "static-3.8733",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9867",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3617",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3728",
  "quartz-webpack": "static-1.3675",
  "foundations-theming-specialty": "static-1.2488",
  "property-description-translator": "static-1.4135",
  "HeadJS": "static-2.796",
  "framer-motion": "static-1.79",
  "hs-test-utils-bend-plugin": "static-1.3439",
  "msw": "static-1.39",
  "testing-library": "static-1.158",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.229",
  "moment-timezone": "static-5.91",
  "jasmine": "static-4.4610",
  "jasmine-runner": "static-1.6749",
  "opentelemetry-fe-types": "static-1.67",
  "dispatcher": "static-1.143",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.878",
  "hubspotter-http": "static-1.4861",
  "mobile-manifest-mixins": "static-1.575",
  "module-federation": "static-1.33",
  "opentelemetry-fe": "static-1.442",
  "quartz-auth": "static-1.1126",
  "quartz-head": "static-1.1116",
  "quartz-i18n": "static-1.1126",
  "quartz-routing": "static-1.881",
  "quartz-test": "static-1.1126",
  "quartz-tracking": "static-1.830",
  "trellis-components": "static-1.2645",
  "ui-fonts": "static-1.1049",
  "usage-tracker-container": "static-1.7627",
  "usage-tracker-core": "static-1.7487",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.189",
  "conversations-skeleton-state": "static-1.7542",
  "reference-resolvers": "static-1.8478",
  "sanitize-text": "static-1.8451",
  "PatternValidationJS": "static-1.3190",
  "ReduxMessenger": "static-2.10667",
  "outpost": "static-1.4452",
  "rpc-client-utils": "static-1.4964",
  "sanitize": "static-1.4769",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1-ech-accordiontransition-jank.34",
  "floating-ui": "static-1.63",
  "hs-story-utils": "static-1.9721",
  "react-aria": "static-1.72",
  "react-create-root-preference": "static-1.69",
  "tanstack-table": "static-1.61",
  "trellis-assets": "static-1.2626",
  "bend-plugin-foundations-theming": "static-1.3255",
  "foundations-theming-base": "static-1.3757",
  "stylex": "static-1.41",
  "hs-locale-management": "static-1.291",
  "csstype": "static-1.50",
  "web-vitals": "static-1.15",
  "ai-components-ui-library": "static-1.9705",
  "atom": "static-1.5383",
  "codemirror": "static-5.102",
  "content-assistance-lib": "static-1.8194",
  "ContentUtils": "static-1.69116",
  "data-token-picker": "static-1.16882",
  "file-manager-components": "static-1.24481",
  "FileManagerCore": "static-1.39980",
  "FileManagerLib": "static-1.40121",
  "frontend-preferences-client": "static-1.8220",
  "hub-http-contrib": "static-1.3335",
  "interframe": "static-3.5052",
  "layout-dnd-components": "static-1.12961",
  "layout-dnd-utils": "static-1.11936",
  "property-translator": "static-1.5692",
  "react-codemirror": "static-1.10937",
  "react-colorpicker": "static-2.10515",
  "reference-resolvers-lite": "static-1.8399",
  "rich-text-lib": "static-1.20300",
  "tinymce-data": "static-1.41180",
  "tinymce-themes": "static-1.57065",
  "ui-addon-emoji-picker": "static-1.10183",
  "ui-addon-sales-email": "static-1.5508",
  "ui-brand-identity-lib": "static-1.16462",
  "bender-build-tools": "static-1.3441",
  "opentelemetry-web": "static-1.13",
  "hub-http-shared-msw-handlers": "static-1.10611",
  "hubspotter-http-shared-msw-handlers": "static-1.10609",
  "usage-tracker-session-replay": "static-1.5323",
  "base-ui": "static-1.22",
  "react-day-picker": "static-1.10",
  "trellis-theming": "static-1.1271",
  "tanstack-virtual": "static-1.38",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.374",
  "chirp-fetch": "static-1.2191",
  "stylex-utils": "static-1.139",
  "chatspot-core": "static-1.23002",
  "copilot-toolkit": "static-1.11842",
  "customer-data-objects-ui-components": "static-1.13327",
  "data-fetching-client": "static-1.9952",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5054",
  "ui-addon-video-player": "static-1.9000",
  "ui-coaching-tips": "static-1.29294",
  "usage-tracker": "static-1.7637",
  "cms-field-types": "static-1.5111",
  "content-icons-ui": "static-1.2360",
  "integrations-lib": "static-1.17016",
  "customer-data-objects": "static-1.7988",
  "apollo-dlb": "static-3.86",
  "breeze-engine-lib": "static-1.1720",
  "apollo-link-hub-http": "static-2.4952",
  "apollo-stack-hubspot": "static-3.94",
  "graphql": "static-1.89",
  "immer": "static-1.101",
  "immerable": "static-1.4445",
  "ui-addon-iframeable": "static-1.9373",
  "video-components-external": "static-1.12138",
  "video-data-lib": "static-1.35796",
  "breeze-artifacts-sdk": "static-1.314",
  "audio-components": "static-1.6338",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29806",
  "FileManagerImages": "static-1.37632",
  "foundations-components-legacy": "static-1-ech-accordiontransition-jank.34",
  "html-to-image": "static-1.61",
  "redux-toolkit": "static-1.78",
  "salesImages": "static-1.559",
  "ui-universal-auth": "static-1.9401",
  "urlinator": "static-1.4829",
  "video-components": "static-1.14140",
  "video-embed": "static-1.36630",
  "ts-schema": "static-1.4290",
  "ContentData": "static-1.69191",
  "layout-data-lib": "static-1.10261",
  "react-dnd-compat": "static-1.4914",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1840",
  "external-options-client-types": "static-1.4336",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7190",
  "hs-promise-utils": "static-1.5892",
  "inbound-db-properties-service-client": "static-1.4052",
  "NamespacedHubStyle": "static-2.9261",
  "growth-onboarding-confetti": "static-1.3358",
  "SharedI18nStrings": "static-1.183",
  "ui-addon-i18n": "static-1.11444",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5750",
  "magpie-types": "static-1.5210",
  "simple-logging-lib": "static-1.3348",
  "avatar-components": "static-1.2777",
  "customer-data-ui-utilities": "static-1.10126",
  "growth-onboarding-feedback-components": "static-1.6881",
  "flux-actions": "static-1.367",
  "hubspot-apollo-client": "static-1.5174",
  "integrations-error-boundary-lib": "static-1.14431",
  "integrations-tracking-lib": "static-1.5904",
  "laboratory-lib": "static-3.7449",
  "native-integrations-shared-strings": "static-1.8074",
  "redux-observable": "static-1.75",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10567",
  "unified-auth": "static-1.915",
  "breeze-engine-chat-components": "static-1.698",
  "breeze-engine-core": "static-1.998",
  "ably": "static-2.2",
  "highlight.js": "static-1.86",
  "navigation-messaging": "static-1.8145",
  "content-media-composition-data-lib": "static-1.13230",
  "content-media-compositions": "static-2.17237",
  "idb-keyval": "static-1.51",
  "media-bridge-lib": "static-1.19400",
  "unified-auth-core-lib": "static-1.1197",
  "social-insights-client-types": "static-1.22706",
  "advanced-menus-core": "static-1.15570",
  "advanced-menus-lib": "static-1.12445",
  "ExportDialog": "static-6.10675",
  "ui-memberships-settings-lib": "static-1.34831",
  "conditional-properties-service-client": "static-1.4011",
  "crm-pipelines-api-client-types": "static-1.4345",
  "fdsr-migration-layer": "static-1.309",
  "framework-builder-read-service-client": "static-1.4217",
  "framework-data-schema-quick-fetch": "static-1.7095",
  "inbound-db-meta-service-client": "static-1.3718",
  "multi-currency-client-types": "static-1.3906",
  "persist-promise": "static-1.3997",
  "foundations-components-test-utils": "static-1-ech-accordiontransition-jank.34",
  "reactive-lib": "static-1.1015",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.633",
  "universal-page-editor-lib": "static-1.3305",
  "adobe-sign-auth-lib": "static-1.448",
  "ads-unified-auth-lib": "static-1.1343",
  "generic-oauth-auth-lib": "static-1.43",
  "google-sheets-integration-lib": "static-1.1018",
  "microsoft-drive-auth-lib": "static-1.132",
  "surveymonkey-integration-lib": "static-1.474",
  "slack-ui-library": "static-1.10696",
  "js-cookie": "static-1.18",
  "fsm": "static-1.4046",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15569",
  "simple-menus-lib": "static-1.17086",
  "crm-record-cards-service-types": "static-1.3783",
  "location-customization-utils-lib": "static-1.10084",
  "react-flip-move": "static-1.78"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30778",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55304",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8328",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyleTokens": "/HubStyleTokens/static-2.11787",
  "I18n": "/I18n/static-7.1672",
  "quartz": "/quartz/static-1.7451",
  "quartz-config": "/quartz-config/static-1.1229",
  "quartz-core": "/quartz-core/static-1.6670",
  "react-dlb": "/react-dlb/static-1.88",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.80",
  "reselect": "/reselect/static-3.12",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.916",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55291",
  "feedback-utils": "/feedback-utils/static-1.55295",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4761",
  "forms-utils-lib": "/forms-utils-lib/static-1.13088",
  "foundations-assets": "/foundations-assets/static-1.5182",
  "foundations-components": "/foundations-components/static-1-ech-accordiontransition-jank.34",
  "foundations-theming": "/foundations-theming/static-1.4772",
  "hub-http": "/hub-http/static-1.6509",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyle": "/HubStyle/static-2.12094",
  "icons": "/icons/static-2.682",
  "immutable": "/immutable/static-2.83",
  "quick-fetch": "/quick-fetch/static-1.4127",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.192",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1.17016",
  "react-select-plus": "/react-select-plus/static-1.113",
  "react-utils": "/react-utils/static-2.5554",
  "react-virtualized": "/react-virtualized/static-2.107",
  "redux": "/redux/static-4.76",
  "StyleGuideUI": "/StyleGuideUI/static-3.501",
  "tinymce-plugins": "/tinymce-plugins/static-1.58209",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1247",
  "UIComponents": "/UIComponents/static-3.8733",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9867",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3617",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3728",
  "quartz-webpack": "/quartz-webpack/static-1.3675",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2488",
  "property-description-translator": "/property-description-translator/static-1.4135",
  "HeadJS": "/HeadJS/static-2.796",
  "framer-motion": "/framer-motion/static-1.79",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3439",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.158",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.229",
  "moment-timezone": "/moment-timezone/static-5.91",
  "jasmine": "/jasmine/static-4.4610",
  "jasmine-runner": "/jasmine-runner/static-1.6749",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.67",
  "dispatcher": "/dispatcher/static-1.143",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.878",
  "hubspotter-http": "/hubspotter-http/static-1.4861",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.575",
  "module-federation": "/module-federation/static-1.33",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.442",
  "quartz-auth": "/quartz-auth/static-1.1126",
  "quartz-head": "/quartz-head/static-1.1116",
  "quartz-i18n": "/quartz-i18n/static-1.1126",
  "quartz-routing": "/quartz-routing/static-1.881",
  "quartz-test": "/quartz-test/static-1.1126",
  "quartz-tracking": "/quartz-tracking/static-1.830",
  "trellis-components": "/trellis-components/static-1.2645",
  "ui-fonts": "/ui-fonts/static-1.1049",
  "usage-tracker-container": "/usage-tracker-container/static-1.7627",
  "usage-tracker-core": "/usage-tracker-core/static-1.7487",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.189",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7542",
  "reference-resolvers": "/reference-resolvers/static-1.8478",
  "sanitize-text": "/sanitize-text/static-1.8451",
  "PatternValidationJS": "/PatternValidationJS/static-1.3190",
  "ReduxMessenger": "/ReduxMessenger/static-2.10667",
  "outpost": "/outpost/static-1.4452",
  "rpc-client-utils": "/rpc-client-utils/static-1.4964",
  "sanitize": "/sanitize/static-1.4769",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1-ech-accordiontransition-jank.34",
  "floating-ui": "/floating-ui/static-1.63",
  "hs-story-utils": "/hs-story-utils/static-1.9721",
  "react-aria": "/react-aria/static-1.72",
  "react-create-root-preference": "/react-create-root-preference/static-1.69",
  "tanstack-table": "/tanstack-table/static-1.61",
  "trellis-assets": "/trellis-assets/static-1.2626",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3255",
  "foundations-theming-base": "/foundations-theming-base/static-1.3757",
  "stylex": "/stylex/static-1.41",
  "hs-locale-management": "/hs-locale-management/static-1.291",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.15",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9705",
  "atom": "/atom/static-1.5383",
  "codemirror": "/codemirror/static-5.102",
  "content-assistance-lib": "/content-assistance-lib/static-1.8194",
  "ContentUtils": "/ContentUtils/static-1.69116",
  "data-token-picker": "/data-token-picker/static-1.16882",
  "file-manager-components": "/file-manager-components/static-1.24481",
  "FileManagerCore": "/FileManagerCore/static-1.39980",
  "FileManagerLib": "/FileManagerLib/static-1.40121",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8220",
  "hub-http-contrib": "/hub-http-contrib/static-1.3335",
  "interframe": "/interframe/static-3.5052",
  "layout-dnd-components": "/layout-dnd-components/static-1.12961",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11936",
  "property-translator": "/property-translator/static-1.5692",
  "react-codemirror": "/react-codemirror/static-1.10937",
  "react-colorpicker": "/react-colorpicker/static-2.10515",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8399",
  "rich-text-lib": "/rich-text-lib/static-1.20300",
  "tinymce-data": "/tinymce-data/static-1.41180",
  "tinymce-themes": "/tinymce-themes/static-1.57065",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10183",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5508",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16462",
  "bender-build-tools": "/bender-build-tools/static-1.3441",
  "opentelemetry-web": "/opentelemetry-web/static-1.13",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10611",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10609",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5323",
  "base-ui": "/base-ui/static-1.22",
  "react-day-picker": "/react-day-picker/static-1.10",
  "trellis-theming": "/trellis-theming/static-1.1271",
  "tanstack-virtual": "/tanstack-virtual/static-1.38",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.374",
  "chirp-fetch": "/chirp-fetch/static-1.2191",
  "stylex-utils": "/stylex-utils/static-1.139",
  "chatspot-core": "/chatspot-core/static-1.23002",
  "copilot-toolkit": "/copilot-toolkit/static-1.11842",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13327",
  "data-fetching-client": "/data-fetching-client/static-1.9952",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5054",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9000",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29294",
  "usage-tracker": "/usage-tracker/static-1.7637",
  "cms-field-types": "/cms-field-types/static-1.5111",
  "content-icons-ui": "/content-icons-ui/static-1.2360",
  "integrations-lib": "/integrations-lib/static-1.17016",
  "customer-data-objects": "/customer-data-objects/static-1.7988",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1720",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4952",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "graphql": "/graphql/static-1.89",
  "immer": "/immer/static-1.101",
  "immerable": "/immerable/static-1.4445",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9373",
  "video-components-external": "/video-components-external/static-1.12138",
  "video-data-lib": "/video-data-lib/static-1.35796",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.314",
  "audio-components": "/audio-components/static-1.6338",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29806",
  "FileManagerImages": "/FileManagerImages/static-1.37632",
  "foundations-components-legacy": "/foundations-components-legacy/static-1-ech-accordiontransition-jank.34",
  "html-to-image": "/html-to-image/static-1.61",
  "redux-toolkit": "/redux-toolkit/static-1.78",
  "salesImages": "/salesImages/static-1.559",
  "ui-universal-auth": "/ui-universal-auth/static-1.9401",
  "urlinator": "/urlinator/static-1.4829",
  "video-components": "/video-components/static-1.14140",
  "video-embed": "/video-embed/static-1.36630",
  "ts-schema": "/ts-schema/static-1.4290",
  "ContentData": "/ContentData/static-1.69191",
  "layout-data-lib": "/layout-data-lib/static-1.10261",
  "react-dnd-compat": "/react-dnd-compat/static-1.4914",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1840",
  "external-options-client-types": "/external-options-client-types/static-1.4336",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7190",
  "hs-promise-utils": "/hs-promise-utils/static-1.5892",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4052",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9261",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3358",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11444",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5750",
  "magpie-types": "/magpie-types/static-1.5210",
  "simple-logging-lib": "/simple-logging-lib/static-1.3348",
  "avatar-components": "/avatar-components/static-1.2777",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10126",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6881",
  "flux-actions": "/flux-actions/static-1.367",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5174",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14431",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5904",
  "laboratory-lib": "/laboratory-lib/static-3.7449",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8074",
  "redux-observable": "/redux-observable/static-1.75",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10567",
  "unified-auth": "/unified-auth/static-1.915",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.698",
  "breeze-engine-core": "/breeze-engine-core/static-1.998",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.86",
  "navigation-messaging": "/navigation-messaging/static-1.8145",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13230",
  "content-media-compositions": "/content-media-compositions/static-2.17237",
  "idb-keyval": "/idb-keyval/static-1.51",
  "media-bridge-lib": "/media-bridge-lib/static-1.19400",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1197",
  "social-insights-client-types": "/social-insights-client-types/static-1.22706",
  "advanced-menus-core": "/advanced-menus-core/static-1.15570",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12445",
  "ExportDialog": "/ExportDialog/static-6.10675",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34831",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4011",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4345",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.309",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4217",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7095",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3906",
  "persist-promise": "/persist-promise/static-1.3997",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1-ech-accordiontransition-jank.34",
  "reactive-lib": "/reactive-lib/static-1.1015",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.633",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3305",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.448",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1343",
  "generic-oauth-auth-lib": "/generic-oauth-auth-lib/static-1.43",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1018",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.132",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.474",
  "slack-ui-library": "/slack-ui-library/static-1.10696",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.4046",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15569",
  "simple-menus-lib": "/simple-menus-lib/static-1.17086",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3783",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10084",
  "react-flip-move": "/react-flip-move/static-1.78"
}
};
